import React from 'react';
import { useGlobalContext } from '../components/GlobalContextProvider';
import {
  DarkModeLoginPMLogoIcon,
  LightModeLoginPMLogoIcon,
} from './LoginPMLogoIcons';

const LoginPMLogo = () => {
  const { theme } = useGlobalContext();
  return theme === 'dark' ? (
    <DarkModeLoginPMLogoIcon />
  ) : (
    <LightModeLoginPMLogoIcon />
  );
};

export default LoginPMLogo;
